import { SelectButton } from "primereact/selectbutton";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Textbox, Textarea } from "react-inputs-validation";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Form,
  Row,
} from "reactstrap";
import { FetchValidarPlacasPolizaCarrito } from "../../redux/actions/ACarritoProductos";
import { setCorreo } from "../../redux/actions/aCotizacion";
import "../../styles/estilos.css";

class ValoresRecompra extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      correo: "",
      visibleAlert: true,
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante",
      claseDivFixPlan: "flex-row div-flotante-km",
      selectedItem: this.props.planSeleccionado,
      correo: "",
      validate: false,
      tieneError: true,
      visibleAlert: true,
    };
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }



  onClickContinuar = (event) => {

    this.props.onContinuar(event);
  };

  onClickEnviar = (event) => {

    event.preventDefault();

    this.setState({ validate: !this.state.validate })

    if (!this.state.tieneError) {
      this.props.metodoEnviar(event);
    }


  };
  /* Eventos Scroll */
  handleScroll() {
    const windowHeight =
      "innerHeight" in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {
      //console.log("total this.props.detalleCarrito.productosCarrito.carProductos.length",this.props.detalleCarrito.productosCarrito.carProductos.length)
      if (
        this.props.detalleCarrito &&
        this.props.detalleCarrito.productosCarrito.carProductos.length > 1
      ) {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix:
              "flex-row div-flotante fix-botton-totales-resumen-multi",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen-multi",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      } else {
        if (windowBottom >= docHeight - 300) {
          this.setState({
            claseDivFix: "flex-row div-flotante fix-botton-totales-resumen",
            claseDivFixPlan:
              "flex-row div-flotante-km fix-botton-totales-resumen",
          });
        } else {
          this.setState({
            claseDivFix: "flex-row div-flotante",
            claseDivFixPlan: "flex-row div-flotante-km",
          });
        }
      }
    } else {
      if (windowBottom >= docHeight - 120) {
        this.setState({
          claseDivFix: "flex-row div-flotante fix-botton-totales",
          claseDivFixPlan: "flex-row div-flotante-km fix-botton-totales",
        });
        //console.log("Scroll TOP");
      } else {
        this.setState({
          claseDivFix: "flex-row div-flotante",
          claseDivFixPlan: "flex-row div-flotante-km",
        });
      }
    }
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  itemTemplate = (option) => {
    //console.log(option);
    return (
      <div
        className='container w-100'
        style={{
          width: "100%",
          border: "1px solid black",
          borderRadius: "4px",
          lineHeight: "15px",
        }}
        key={option.codigo}>
        <small style={{ fontSize: "10px" }}>{option.plan}</small>
        <br />
        <strong style={{ fontSize: "11px" }}>${option.valor}</strong>
        <br />
        <small style={{ fontSize: "10px" }}>
          Vigencia: {option.vigenciaDias}
        </small>
      </div>
    );
  };

  onChangeItem = ({ value }) => {
    //value=== plan
    this.props.onSelect(value);
  };

  onActualizar = ({ value }) => {
    //value=== plan
    this.props.onActualizar();
  };

  render() {
    let textoBoton = "CONTINUAR";
    let { formEditado, completo } = this.props;
    const {
      correo,
      claseDivFix,
      claseDivFixPlan,
    } = this.state;
    if (
      this.props.paso === "confirmacion-cotizacion" &&
      this.props.dataUsuario.usu_tipo_usuario === "cliente"
    ) {
      textoBoton = "PAGAR";
    }

    return (
      <div>
        <div>
          <Card style={{ width: "99%" }}>
            {((this.props.codigoProductoEspecial &&
              this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
              this.props.planes != null &&
              this.props.planes.length > 0) || (this.props.recompra)) && (
                <CardHeader style={{ position: "" }}>
                  <strong>Selecciona tu Plan Ideal</strong>
                </CardHeader>
              )}
            <CardBody>
              <div>
                {((this.props.codigoProductoEspecial &&
                  this.props.codeProductoEspecial !== "KilometrosConsumidos" &&
                  this.props.planes != null &&
                  this.props.planes.length > 0) || (this.props.recompra)) && (
                    <div>
                      <div class=''>
                        <Form style={{ width: "99%" }}>
                          {this.props.planes != null && (
                            <SelectButton
                              value={this.props.planSeleccionado}
                              disabled={completo}
                              options={this.props.planes}
                              onChange={this.onChangeItem}
                              optionLabel='codigo'
                              //optionValue="codigo"
                              itemTemplate={this.itemTemplate}
                              className='vertically w-100 my-3'
                              dataKey='codigo'
                            />
                          )}
                        </Form>
                      </div>
                    </div>
                  )}
              </div>
              <div>
                {(
                  <div>
                    <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>Prima Neta</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <h5>${this.props.totales.prima_neta_anual_full_cobertura}</h5>
                      </Col>
                    </Row>
                    <Row>
                      <div id='container-imp'>
                        <div className='accordion-imp'>
                          <input type='checkbox' id='tm' />
                          <label htmlFor='tm' className='accordionitem'>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5
                                  title={
                                    "Presiona click para ver/ocultar el detalle impuestos"
                                  }>
                                  Impuestos{" "}
                                  <i
                                    className='fa fa-info-circle'
                                    aria-hidden='true'
                                  />
                                </h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.props.totales.totalImpuestos}</h5>
                              </Col>
                            </Row>
                          </label>
                          <div className='hiddentext ocultar'>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>IVA</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.props.totales.iva_Full_Cobertura}</h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Super bancos 3.5 %</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.props.totales.super_bancos_Full_Cobertura}</h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Seguro Campesino</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>
                                  ${this.props.totales.seguro_campesino_Full_Cobertura}
                                </h5>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>Derechos de Emisión</h5>
                              </Col>
                              <Col lg={6} md={6} sm={6} xs={6}>
                                <h5>${this.props.totales.derecho_emision_Full_Cobertura}</h5>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Row>
                    <Row>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <p />
                        <h5 style={{ fontWeight: "bold" }}>
                          $
                          {this.props.paso === "datos-cotizacion"
                            ? this.props.totales.primaTotal_Full_Cobertura
                            : this.props.totales.totalcarrito}
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>

                        {this.props.urlPdf && formEditado == false && (
                          <div>
                            <hr />
                            <a
                              className='btn btn-detail-white'
                              href={this.props.urlPdf}
                              target='_blank'
                              rel='noopener noreferrer'>
                              <i
                                className='fa fa-cloud-download'
                                aria-hidden='true'
                              />{" "}

                              DESCARGAR COTIZACIÓN
                            </a>
                          </div>
                        )}
                      </Col>








                      {/* <Col lg={12} md={12} sm={12} xs={12}>
                      <Button
                        className='btn btn-detail-white'
                        onClick={this.onClickDescargar}>
                        <i
                          className='fa fa-cloud-download'
                          aria-hidden='true'
                        />{" "}
                        DESCARGAR COTIZACIÓN
                      </Button>
                      <br></br>
                    </Col> */}

                    </Row>
                    {this.props.urlPdf && formEditado == false &&
                      <Row>
                        <Col lg={8} md={12} sm={12} xs={12}>
                          <Textbox
                            tabIndex="1"
                            type="input"
                            value={this.props.email}
                            name="correo"
                            id="correo"
                            classNameInput={"form-control"}
                            onChange={(correo, e) => {
                              this.props.setEmail(correo)
                            }}
                            placeholder="Por favor ingrese el correo" // Optional.[String].Default: "".
                            validate={this.state.validate}
                            validationCallback={(res) => {

                              console.log('resfs', res)

                              //setHasCorreoError(res)
                              this.setState({ validate: !res, tieneError: res })



                            }} // Optional.[Func].Default: none. Return the validation result.
                            onBlur={(e) => {
                              // this.setState({ blur: true });
                              //console.log("BLUUUR");
                            }}
                            validationOption={{
                              name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                              check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                              required: true,
                              reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              regMsg: "Por favor ingrese un correo válido",
                              msgOnError: "Por favor ingrese un correo válido", // Optional.[Bool].Default: true. To determin if it is a required field.
                            }}
                          />
                        </Col>
                        <Col lg={4} md={12} sm={12} xs={12}>
                          <Button
                            className='btn btn-detail-white'
                            onClick={this.onClickEnviar}>
                            <i className='fa fa-trash-o' aria-hidden='true' />{" "}
                            ENVIAR
                          </Button>

                        </Col>
                        {this.props.datosCotizacion.envioOK && (
                          <Alert
                            color='success'
                            isOpen={this.state.visibleAlert}
                            toggle={this.onDismiss}>
                            <center>
                              <p>
                                Se ha enviado correctamente la cotización al
                                correo electrónico ingresado.
                              </p>
                            </center>
                          </Alert>
                        )}


                      </Row>

                    }

                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <hr></hr>
                        {!completo && <Button
                          className={
                            formEditado
                              ? "btn btn-primary btn-purple fe-pulse"
                              : "btn btn-primary"
                          }
                          onClick={formEditado ? this.onActualizar : this.onClickContinuar}
                          disabled={this.props.disabled || false}
                          style={{ display: "block", margin: "auto" }}>
                          <i
                            className='fa fa-chevron-circle-right'
                            aria-hidden='true'
                          />{" "}
                          {formEditado ? "ACTUALIZAR" : textoBoton}
                        </Button>}
                        <br></br>
                      </Col>
                    </Row>

                  </div>
                )}












              </div>









            </CardBody>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  detalleCarrito: state.dataProductoCarrito,
  dataUsuario: state.datosUsuarios.dataUsuario,
  datosCotizacion: state.datosCotizacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setCorreo: (data) => dispatch(setCorreo(data)),
    fetchValidarPlacasPolizaCarrito: (datos) =>
      dispatch(FetchValidarPlacasPolizaCarrito(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ValoresRecompra)
);